import styled from 'styled-components';

export const Button = styled.button`
  width: 100%;
  font-size: 16px;
  height: 40px;
  border: 2px solid var(--bg-button-default-color);
  border-radius: 5px;
  color: var(--button-text-color);
  background-color: var(--bg-button-default-color);
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--button-hover-color);
    border-color: var(--button-hover-color);
    cursor: pointer;
  }
`;
export const SpanButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: inherit;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    border-radius: 50%;
    background: var(--bg-button-default-color);
    path {
      fill: var(--white-color);
    }
  }
`;
